import React, { useState } from "react";

import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import CustomPagination from "../components/CustomPagination";
import FilterMenu from "../components/filterMenu";
import SearchBar from "../components/SearchBar";
import MainContainer from "../layout/MainContainer";
import SubscriptionTable from "../pages/manage-subscription/subscriptionTable";
import { isValidInput } from "../utils/validations";

export const CoupanManagement = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  return (
    <MainContainer>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1 className="">Coupon Management</h1>
        </div>

        <div className="right_s">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                placeholder="Search...."
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-coupan/add")}
          >
            + Add Coupan
          </Button>
          <FilterMenu
            startDate={null}
            endDate={null}
            setStartDate={() => { }}
            setEndDate={() => { }}
          />
        </div>
      </div>

      <div className="cards table_cards">
        <SubscriptionTable
          data={[]}
          getSubscriptionApi={() => { }}
          hasFetched={false}
        />
      </div>
      <CustomPagination />
    </MainContainer>
  );
};

export default CoupanManagement;
